// extracted by mini-css-extract-plugin
export default {"ImageWrapper":"Recordings_ImageWrapper__ATT-L","figure":"Recordings_figure__i7i9H","pagefooter":"Recordings_pagefooter__mKwBC","pagewrapper":"Recordings_pagewrapper__1NSwe"};